/**
 * Detect Electron renderer process, which is node, but we should
 * treat as a browser.
 */

if (typeof process === 'undefined' || process.type === 'renderer') {
  module.exports = require('./browser.js');
} else {
  module.exports = require('./node.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/debug/src/index.js
// module id = 1
// module chunks = 0 1